import { render } from "./enquiryDetails.vue?vue&type=template&id=72903c20&scoped=true"
import script from "./enquiryDetails.vue?vue&type=script&lang=js"
export * from "./enquiryDetails.vue?vue&type=script&lang=js"

import "./enquiryDetails.vue?vue&type=style&index=0&id=72903c20&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72903c20"]])

export default __exports__